import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { ApiState } from "infrastructure/api";
import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiRouteTypes } from "consts/enpoints/api";
import { concat } from "util/support";
import { payloadCreator } from "util/api";
import type { Application, ApplicationsResponse, WithRejectReson, WithUser } from "./types";
import { sliceToken } from "./state";
import { deleteApplication, getApplications, putApplication } from "./api";

export const getApplicationsThunk: AsyncThunk<
    ThunkReturnType<ApplicationsResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetApplications]),
    payloadCreator(getApplications),
    {
        condition: (_, { getState }) => {
            const { onboarding } = getState() as RootState;

            return (
                ![ApiState.Pending].includes(onboarding.tableLoadingState)
            );
        }
    }
);

export const putApplicationThunk: AsyncThunk<
    ThunkReturnType<ResourceResponse<Application>>,
    WithUser & Partial<WithRejectReson<Application>>,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.PutApplications]),
    payloadCreator(putApplication),
    {
        condition: (_, { getState }) => {
            const { onboarding } = getState() as RootState;

            return ![ApiState.Pending].includes(onboarding.tableLoadingState);
        }
    }
);

export const deleteApplicationThunk: AsyncThunk<
    ThunkReturnType<ResourceResponse<ID>>,
    WithUser,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.DeleteApplications]),
    payloadCreator(deleteApplication),
    {
        condition: (_, { getState }) => {
            const { onboarding } = getState() as RootState;

            return ![ApiState.Pending].includes(onboarding.tableLoadingState);
        }
    }
);
